<template>
  <!-- 权限申请配置页面 -->
  <mtd-loading :loading="page_loading">
    <mtd-row>
      <!--  标题及按钮  -->
      <mtd-row class="margin-bottom-0" style="margin-top: 16px;">
        <div class="page-title-22">注：当前页面只能查看本人当天的日志信息</div>
      </mtd-row>
      <!-- 搜索框 -->
      <mtd-row class="margin-bottom-0 policy-search-block" style="margin-top: 16px;">
        <mtd-col :span="8" class="height-full">
          <mtd-form inline :label-width="74">
            <mtd-form-item label="动作:" style="margin-bottom: 0;width: 100%;">
              <mtd-select placeholder="全部" v-model="search_form.queryAction" style="width: 100%;">
                <mtd-option value="" label="全部"/>
                <mtd-option value="copy" label="复制"/>
                <mtd-option value="screenshot" label="截屏"/>
                <mtd-option value="screenrecord" label="录屏"/>
                <mtd-option value="file_share" label="禁止文件分享"/>
              </mtd-select>
            </mtd-form-item>
          </mtd-form>
        </mtd-col>
        <mtd-col :span="8" :offset="8" class="margin-bottom-0 text-right">
          <mtd-button type="primary" @click="load_log_list()" style="margin-right: 0; width: 82px;">查询</mtd-button>
        </mtd-col>
      </mtd-row>
      <!--  表格数据  -->
      <div style="margin-top: 12px">
        <mtd-table size="small" :data="log_list">
          <mtd-table-column prop="log_report_mis_id" label="misId" width="150" show-overflow-tooltip/>
          <mtd-table-column prop="log_report_device_id" label="deviceId" width="200" show-overflow-tooltip/>
          <mtd-table-column prop="log_report_app_id" label="appId" width="100" show-overflow-tooltip/>
          <mtd-table-column prop="log_report_action" label="动作" width="150" show-overflow-tooltip/>
          <mtd-table-column prop="log_report_content" label="内容" show-overflow-tooltip/>
          <mtd-table-column prop="log_report_windows_tag" label="windowsTag" show-overflow-tooltip/>
          <mtd-table-column prop="request_time" label="时间" width="150"/>
        </mtd-table>
        <mtd-pagination :total="search_form.total" :show-total="true" :current-page.sync="search_form.page"
                        @change="load_log_list()" size="small" style="float: right;margin-top: 12px"/>
      </div>
    </mtd-row>
  </mtd-loading>
</template>

<script>
  import {mapActions} from "vuex";
  import moment from "moment";

  export default {
    name: "query_mobile_log",
    filters: {
      dateTimeFormat(dateTime) {
        return moment(dateTime)
          .utcOffset(480)
          .format('YYYY-MM-DD HH:mm:ss');
      },
    },
    data() {
      return {
        page_loading: false,
        log_list: [],
        search_form: {
          queryAction: "",
          total: 0,
          page: 1,
          limit: 10
        }
      }
    },
    computed: {},
    mounted() {
      this.load_log_list();
    },
    methods: {
      ...mapActions({
        'api_select_log_list': 'api_mobile_protect_common_query_select_log_list',
      }),
      load_log_list() {
        this.page_loading = true;
        this.api_select_log_list(this.search_form).then((res) => {
          const {total, limit, currentPage, data} = res.data;
          this.search_form.total = total;
          this.search_form.page = currentPage;
          this.search_form.limit = limit;
          this.log_list = data;
          this.page_loading = false;
        });
      },
    }
  }
</script>

<style scoped>
  .policy-search-block .mtd-form-item {
    width: 100%;
  }

  .policy-search-block {
    background: #F7F7F7;
    padding: 12px 16px;
  }
</style>
